import { LocalizedText } from "@/i18n/LocalizedText";
import { Check, CircleMinus, Trash2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./ui/alert-dialog";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import { useSidebar } from "./ui/sidebar";
import { type Table } from "@tanstack/react-table";

const PromptsInactive = ({
  inactiveRowSelection,
  inactiveTable,
  handleStatusChange,
  handleDeleteSelected,
}: {
  inactiveRowSelection: any;
  inactiveTable: Table<any>;
  handleStatusChange: any;
  handleDeleteSelected: any;
}) => {
  const { state } = useSidebar();

  return (
    <AlertDialog>
      <div
        style={{
          width:
            window.innerWidth >= 768
              ? `calc(100vw - ${state === "collapsed" ? "80" : "240"}px)`
              : "100%",
          left:
            window.innerWidth >= 768
              ? `${state === "collapsed" ? "80" : "240"}px`
              : "0",
        }}
        className={`border-t flex justify-center fixed transition-all duration-300 bottom-0 bg-white w-full md:w-auto`}
      >
        <div
          className={`${Object.keys(inactiveRowSelection).length > 0 ? "flex my-2 " : "hidden"} border-[#898989] gap-2 w-fit bg-[#171717] text-[#FAFAFA] p-2 items-center rounded-lg justify-center`}
        >
          <div className="flex  w-fit items-center border border-[#898989] rounded-lg">
            <span className="mx-2 text-xs font-normal">
              {Object.keys(inactiveRowSelection).length} selected
            </span>
            <Separator
              orientation="vertical"
              className="bg-[#898989] data-[orientation=vertical]:h-[20px]"
            ></Separator>
            <Button
              disabled={inactiveTable.getSelectedRowModel().rows.length === 0}
              onClick={() => inactiveTable.resetRowSelection()}
              className="w-fit cursor-pointer has-[>svg]:px-2"
            >
              <CircleMinus size={16} />
            </Button>
          </div>
          <Separator
            orientation="vertical"
            className="bg-[#898989] data-[orientation=vertical]:h-[30px]"
          ></Separator>
          <AlertDialogTrigger asChild>
            <Button
              type="button"
              disabled={inactiveTable.getSelectedRowModel().rows.length === 0}
              className={`flex text-xs gap-2 px-2 py-2 border border-[#898989] rounded-md transition-colors 
                      duration-200 cursor-pointer hover:bg-primary/90 focus:outline-none 
                      focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary 
                      ${inactiveTable.getSelectedRowModel().rows.length === 0 ? "opacity-50 cursor-not-allowed pointer-events-none bg-primary/50 hover:bg-primary/50" : ""}`}
            >
              <Trash2 size={16} /> <LocalizedText id="legacy.delete.16wmut8" />
            </Button>
          </AlertDialogTrigger>
          <button
            onClick={() => handleStatusChange(true, inactiveTable)}
            className="flex justify-center"
          >
            <div
              className={`flex gap-2 text-xs px-2 py-2 border border-[#898989] rounded-md transition-colors 
                      duration-200 cursor-pointer hover:bg-primary/90 focus:outline-none 
                      focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary 
                      ${inactiveTable.getSelectedRowModel().rows.length === 0 && "opacity-50 cursor-not-allowed pointer-events-none bg-primary/50 hover:bg-primary/50"}`}
            >
              <Check size={16} /> <LocalizedText id="legacy.activate.1ps4pgc" />
            </div>
          </button>
        </div>
      </div>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-center">
            <LocalizedText id="legacy.are.you.sure.you.want.to.delete.prompts.ad3lb8" />
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="cursor-pointer">
            <LocalizedText id="legacy.cancel.18x3nqb" />
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() =>
              handleDeleteSelected(inactiveTable, "inactive", null)
            }
            className="hover:bg-[#ff8138] hover:text-white text-white cursor-pointer bg-[#FF5E00]"
          >
            <LocalizedText id="legacy.delete.16wmut8" />
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default PromptsInactive;
